import React from "react";
import "./feedbackOverlay.css";
import { IObservable } from "../../observable/observable";

export type FeedbackOverlayProps = {
  feedbackObservable: IObservable<string>;
  /** The word currently being spelled; used to clear lingering feedback. */
  currentWord: string;
};

export function FeedbackOverlay(props: FeedbackOverlayProps) {
  const [feedbackList, setFeedbackList] = React.useState<string[]>([]);

  React.useEffect(() => {
    const unsubscribe = props.feedbackObservable.subscribe((newFeedback: string) => {
      setFeedbackList((oldList: string[]) => {
        const newFeedbackList = oldList.slice();
        newFeedbackList.push(newFeedback);
        return newFeedbackList;
      });
    });

    return () => {
      unsubscribe();
    };
  }, [props.feedbackObservable, setFeedbackList]);

  // Hide any lingering feedback the moment a new word starts being spelled,
  // so the transient message never sits under the new word.
  React.useEffect(() => {
    if (props.currentWord && props.currentWord.length > 0) {
      setFeedbackList([]);
    }
  }, [props.currentWord]);

  return (
    <>
      {feedbackList.map((feedback: string, index: number) => {
        return (
          <div key={index} className="feedbackOverlay">
            {feedback}
          </div>
        );
      })}
    </>
  );
}
